module.exports = __webpack_public_path__ + "7446dac7740cdf0cdbb4a0fc263dfaae.png";